import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from "@chakra-ui/react";
import { expertsArray } from "../../Config/experts";
import { updateData } from "../../Config/functions";
import AssessmentDataService from "../../services/Assessment";
export const ExpertModal = ({ isOpen, onClose, row, func }: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();
  const sendExpertMessage = () => {
    let template: string = "";
    let dynamic_data: any;
    if (
      row.data.screening_result.suggested_expert_name1 &&
      row.data.screening_result.suggested_expert_name2 &&
      row.data.screening_result.suggested_expert_name3
    ) {
      const expert1:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name1
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name1
          ? row.data.screening_result.suggested_expert_name1
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      const expert2:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name2
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name2
          ? row.data.screening_result.suggested_expert_name2
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      const expert3:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name3
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name3
          ? row.data.screening_result.suggested_expert_name3
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      template = "new_expert_mapping_three_experts";
      dynamic_data = {
        key1: row.data.client_information.name,
        key2: `${expert1.name} | ${expert1.position} ${
          expert1.app_link ? expert1.app_link : expert1.link
        }`,
        key3: `${expert2.name} | ${expert2.position} ${
          expert2.app_link ? expert2.app_link : expert2.link
        }`,
        key4: `${expert3.name} | ${expert3.position} ${
          expert3.app_link ? expert3.app_link : expert3.link
        }`,
      };
    } else if (
      (row.data.screening_result.suggested_expert_name1 &&
        row.data.screening_result.suggested_expert_name2) ||
      (row.data.screening_result.suggested_expert_name1 &&
        row.data.screening_result.suggested_expert_name3) ||
      (row.data.screening_result.suggested_expert_name2 &&
        row.data.screening_result.suggested_expert_name3)
    ) {
      template = "new_expert_mapping__two_experts";
      dynamic_data = {
        key1: row.data.client_information.name,
        key2: "",
        key3: "",
      };
      if (
        row.data.screening_result.suggested_expert_name1 &&
        row.data.screening_result.suggested_expert_name2
      ) {
        const expert1:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name1
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name1
            ? row.data.screening_result.suggested_expert_name1
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };
        const expert2:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name2
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name2
            ? row.data.screening_result.suggested_expert_name2
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };

        dynamic_data.key2 = `${expert1.name} | ${expert1.position}, ${
          expert1.app_link ? expert1.app_link : expert1.link
        }`;
        dynamic_data.key3 = `${expert2.name} | ${expert2.position}, ${
          expert2.app_link ? expert2.app_link : expert2.link
        }`;
      } else if (
        row.data.screening_result.suggested_expert_name2 &&
        row.data.screening_result.suggested_expert_name3
      ) {
        const expert1:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name2
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name2
            ? row.data.screening_result.suggested_expert_name2
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };
        const expert2:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name3
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name3
            ? row.data.screening_result.suggested_expert_name3
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };

        dynamic_data.key2 = `${expert1.name} | ${expert1.position}, ${
          expert1.app_link ? expert1.app_link : expert1.link
        }`;
        dynamic_data.key3 = `${expert2.name} | ${expert2.position}, ${
          expert2.app_link ? expert2.app_link : expert2.link
        }`;
      } else {
        const expert1:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name1
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name1
            ? row.data.screening_result.suggested_expert_name1
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };
        const expert2:
          | {
              expertId: string;
              name: string;
              position: string;
              link: string;
              app_link: string;
            }
          | undefined = expertsArray.find(
          (el) =>
            el.expertId == row.data.screening_result.suggested_expert_name3
        ) || {
          expertId: "",
          name: row.data.screening_result.suggested_expert_name3
            ? row.data.screening_result.suggested_expert_name3
                .split("_")[1]
                .toUpperCase()
            : "",
          position: "",
          link: "https://www.manoshala.com/sessions",
          app_link: "",
        };

        dynamic_data.key2 = `${expert1.name} | ${expert1.position}, ${
          expert1.app_link ? expert1.app_link : expert1.link
        }`;
        dynamic_data.key3 = `${expert2.name} | ${expert2.position}, ${
          expert2.app_link ? expert2.app_link : expert2.link
        }`;
      }
    } else if (
      row.data.screening_result.suggested_expert_name1 ||
      row.data.screening_result.suggested_expert_name2 ||
      row.data.screening_result.suggested_expert_name3
    ) {
      template = "new_expert_mapping_one_expert";
      dynamic_data = {
        key1: row.data.client_information.name,
        key2: "",
      };
      const expert1:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name1
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name1
          ? row.data.screening_result.suggested_expert_name1
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      const expert2:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name2
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name2
          ? row.data.screening_result.suggested_expert_name2
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      const expert3:
        | {
            expertId: string;
            name: string;
            position: string;
            link: string;
            app_link: string;
          }
        | undefined = expertsArray.find(
        (el) => el.expertId == row.data.screening_result.suggested_expert_name3
      ) || {
        expertId: "",
        name: row.data.screening_result.suggested_expert_name3
          ? row.data.screening_result.suggested_expert_name3
              .split("_")[1]
              .toUpperCase()
          : "",
        position: "",
        link: "https://www.manoshala.com/sessions",
        app_link: "",
      };
      if (row.data.screening_result.suggested_expert_name1) {
        dynamic_data.key2 = `${expert1.name} | ${expert1.position}, ${
          expert1.app_link ? expert1.app_link : expert1.link
        }`;
      } else if (row.data.screening_result.suggested_expert_name2) {
        dynamic_data.key2 = `${expert2.name} | ${expert2.position}, ${
          expert2.app_link ? expert2.app_link : expert2.link
        }`;
      } else {
        dynamic_data.key2 = `${expert3.name} | ${expert3.position}, ${
          expert3.app_link ? expert3.app_link : expert3.link
        }`;
      }
    }
    const clientData: any = [
      {
        phone_number: "91" + row.data.client_information.phone,
        name: row.data.client_information.name,
        dynamic_data: dynamic_data,
      },
    ];
    const data: any = updateData(
      row,
      row.data.expert,
      "EHC Followup Experts Details",
      "EXPERT_ASSIGNED",
      template
    );
    const templateName = template;
    if (
      !row.data.screening_result.suggested_expert_name1 &&
      !row.data.screening_result.suggested_expert_name2 &&
      !row.data.screening_result.suggested_expert_name3
    ) {
      toast({
        position: "top",
        title: "Message Failed.",
        description: "Expert is not assigned",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    } else {
      AssessmentDataService.sendMessage(
        { templateName: templateName, clientdata: clientData },
        token
      )
        .then((res) => {
          AssessmentDataService.update(data, row.id, token)
            .then((response: any) => {
              toast({
                position: "top",
                title: "Message Sent Successfully.",
                status: "success",
                duration: 1000,
                isClosable: true,
              });
              func("DAY1_FIRST");
              onClose();
            })
            .catch((e: Error) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Expert Details Message</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to send expert details message?
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={sendExpertMessage}
          >
            Send message
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
